import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../components/auth/useAuth'
import { addUser, getUsers, editUser, enableUser, disableUser } from '../../../actions/usersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import UserForm from '../../../components/forms/UserForm'
import { getDepartmentsForSelect } from '../../../actions/departmentsActions'

export default function Users() {
    const { t } = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()
    const { clientauth } = useAuth()

    const { users, resultuser, loading, total } = useSelector(state => state.users)
    const { departments } = useSelector(state => state.departments)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)
    const [filterActive, setFilterActive] = useState(true)

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')

    useEffect(() => {
        if (clientauth) {
            dispatch(getUsers(page, limit, search))
        }
    }, [dispatch, t, clientauth, location, page, limit, search])

    useEffect(() => {
        dispatch(getDepartmentsForSelect())
    }, [dispatch])

    const openModal = () => {
        setIsAddingOrEditing('adding')
        setFormState({
            username: '',
            email: '',
            password: '',
                    rol: 'department',
            departments: []
        })
        setModalShow(true)
    }

    const selectUser = (user) => {
        setIsAddingOrEditing('editing')
        setFormState({
            _id: user._id,
            username: user.username || '',
            email: user.email || '',
            password: '',
            rol: String(user.rol || '').toLowerCase(),
            departments: Array.isArray(user.departments) ? user.departments : [],
            active: user.active
        })
        setModalShow(true)
    }

    const handleInputChange = ({ target }) => {
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleDepartmentToggle = (department) => {
        const currentDepartments = Array.isArray(formState.departments)
            ? formState.departments
            : []

        setFormState({
            ...formState,
            departments: currentDepartments.includes(department)
                ? currentDepartments.filter(item => item !== department)
                : [
                    ...currentDepartments,
                    department
                ]
        })
    }

    const normalizeDepartments = (departments = []) => {
        return [...new Set(
            departments
                .map(department => String(department || '').trim().toUpperCase())
                .filter(Boolean)
        )]
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsRegistering(true)

        const dataToSend = {
            username: formState.username,
            email: formState.email,
            rol: formState.rol,
            active: formState.active,
            departments: normalizeDepartments(formState.departments || [])
        }

        // Solo enviar password si el admin escribió una nueva (evita machacarla por autofill/error)
        if (typeof formState.password === 'string' && formState.password.trim() !== '') {
            dataToSend.password = formState.password
        }

        if (isAddingOrEditing === 'editing') {
            dispatch(editUser(dataToSend, formState._id))
        } else {
            dispatch(addUser(dataToSend))
        }
        setIsRegistering(false)
    }

    const disableEnableUsers = async (e) => {
        e.preventDefault()
        let textQuestion = ''
        formState.active
            ?
            textQuestion = t('admin.users.areyousuredisable') + '<br><p><label className="fs-20 fw-600 pt-5">' + formState?.username + '</label></p>'
            :
            textQuestion = t('admin.users.areyousureenable') + '<br><p><label className="fs-20 fw-600 pt-5">' + formState?.username + '</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'question',
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (formState.active) {
                    dispatch(disableUser(formState._id))
                } else {
                    dispatch(enableUser(formState._id))
                }
            }
        })
    }

    useEffect(() => {
        if (resultuser) {
            let resultuserTemp = resultuser
            dispatch({ type: 'USER_RESET_RESULT' })
            switch (resultuserTemp) {
                case 'userCreated':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.users.emailExists')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successEnable':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.enablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successDisable':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.disablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line
    }, [resultuser])

    const columnsUsers = [
        {
            name: t('admin.users.email'),
            minWidth: '160px',
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.email}
                </div>,
            selector: (user) => user.email,
            sortable: true,
        }, {
            name: t('admin.users.username'),
            minWidth: '110px',
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.username}
                </div>,
            selector: (user) => user.username,
            sortable: true,
        }, {
            name: t('admin.users.rol'),
            minWidth: '90px',
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {t('admin.users.' + String(user.rol || '').toLowerCase())}
                </div>,
            selector: (user) => user.rol,
            sortable: true,
            hide: 'sm',
        }, {
            name: t('admin.users.active'),
            width: '70px',
            minWidth: '70px',
            cell: user =>
                <div>
                    {user.active
                        ?
                        <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                        <img src="../images/times.svg" alt="times" width={25}></img>
                    }
                </div>,
            selector: (user) => user.active,
            sortable: true,
            hide: 'sm',
        },
    ]

    const filteredUsers = (users || []).filter(user => user?.active === filterActive)

    return (
        <>
            <div className="toolbar">
                <div className="toolbar-left">
                    <div className="filter-pills">
                        <button
                            className={`filter-pill${filterActive === true ? ' active' : ''}`}
                            onClick={() => { setFilterActive(true); setPage(1) }}
                        >
                            {t('admin.users.enabled')}
                        </button>
                        <button
                            className={`filter-pill${filterActive === false ? ' active' : ''}`}
                            onClick={() => { setFilterActive(false); setPage(1) }}
                        >
                            {t('admin.users.disabled')}
                        </button>
                    </div>
                    <div className="input-group" style={{ maxWidth: '280px' }}>
                        <span className="input-group-text"><i className="fas fa-search"></i></span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={t("datatables.buscar")}
                            value={searchAux || ""}
                            onChange={e => {
                                setSearchAux(e.target.value);
                                setPage(1);
                            }}
                            onKeyDown={(e) => { if (e.key === 'Enter') { setSearch(searchAux); setPage(1); } }}
                        />
                    </div>
                </div>
                <div className="toolbar-right">
                    <Button variant='success' onClick={() => openModal()}>
                        <i className='fas fa-user-plus'></i>{t('admin.users.createuser')}
                    </Button>
                </div>
            </div>

            {loading ? (
                <Loader />
            ) : filteredUsers?.length > 0 ? (
                <div className="card-simple">
                    <CustomDataTable
                        columns={columnsUsers}
                        data={filteredUsers}
                        pagination
                        paginationServer
                        paginationTotalRows={total}
                        exportable={false}
                        printable={false}
                        searchable={'custom'}
                        searchText={search}
                        onChangeRowsPerPage={(newLimit) => {
                            setLimit(newLimit)
                            setPage(1)
                        }}
                        onChangePage={(newPage) => {
                            setPage(newPage)
                        }}
                        onRowClicked={(row) => selectUser(row)}
                    />
                </div>
            ) : (
                <div className="empty-state">
                    <div className="empty-state-icon"><i className="fas fa-users"></i></div>
                    <div className="empty-state-text">{t('admin.users.thereisnotusers')}</div>
                </div>
            )}
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.users.users')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        disableEnableUsers={disableEnableUsers}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        departments={departments}
                        handleDepartmentToggle={handleDepartmentToggle}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}
